import { LOCALE } from '@/utils/date';
import { CURRENCIES_ASSOCIATION } from '@/constants';

export function formatPriceByLanguage(
  priceInCents: number,
  activeLanguage: LOCALE,
  currencySymbol: string
): string {
  if (activeLanguage === 'en') {
    const formattedPrice = new Intl.NumberFormat('en', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(priceInCents / 100);
    return `${currencySymbol}${formattedPrice}`;
  }
  return `${new Intl.NumberFormat('de', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(priceInCents / 100)}${' '}${currencySymbol}`;
}

export function formatPriceFromObject(
  price: { inCents: number; currency: string } | null | undefined,
  activeLanguage: LOCALE
): string | null {
  if (!price) {
    return null;
  }

  const currencySymbol = CURRENCIES_ASSOCIATION[price.currency] ?? price.currency;
  return formatPriceByLanguage(price.inCents, activeLanguage, currencySymbol);
}
